// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".editor[data-v-f9ebbbd6] .w-e-panel-container{z-index:3;position:absolute;left:150px;border:1px solid #ccc;box-shadow:1px 1px 2px #ccc;color:#333;background-color:#fff}.editor[data-v-f9ebbbd6] .w-e-text-container{z-index:1!important;position:static}.editor[data-v-f9ebbbd6] .w-e-toolbar{-webkit-flex-wrap:wrap;-ms-flex-wrap:wrap;flex-wrap:wrap}.editor[data-v-f9ebbbd6] .w-e-menu{z-index:auto!important}.editor[data-v-f9ebbbd6] .w-e-droplist{z-index:3!important}", ""]);
// Exports
module.exports = exports;
